import { Component, OnDestroy, OnInit, Optional } from '@angular/core';
import { HvlAbstractLazyList } from '@hvlng/framework-core/form';
import { HvlFormGroup } from '@hvlng/framework-bff/core';
import { PageCode } from 'humanresources-common-shared';
import { LazyLoadEvent } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UiEnumService, UiToastMessageService, UiTranslateLoaderService } from 'ui-shared';
import { PositionModel } from '../../position-management/model/position-model';
import { PositionQueryModel } from '../../position-management/model/position-query-model';
import { Subscription } from 'rxjs';
import { PersonnelSharedService } from '../../../../service/personnel-shared-service';

@Component({
    selector: 'position-picker-list',
    templateUrl: './position-picker-list.component.html',
})
export class PositionPickerListComponent extends HvlAbstractLazyList<PositionModel> implements OnInit, OnDestroy {
    tableList;
    form = new HvlFormGroup<PositionQueryModel>(new PositionQueryModel());
    selectedItem;
    selectionMode;
    pageCode: string = PageCode.CONTRACT;
    isClear: boolean;
    listSubscription: Subscription;
    dataKey: string = 'id';
    showFullStaffDetail;
    showAvailableStaff;
    showDate=false;
    constructor(
        private positionService: PersonnelSharedService,
        private enumService: UiEnumService,
        protected translateService: UiTranslateLoaderService,
        private uiToastMessageService: UiToastMessageService,
        @Optional() public dynamicDialogRef: DynamicDialogRef,
        @Optional() private dialogConfig: DynamicDialogConfig,
    ) {
        super();
    }

    ngOnInit(): void {
        this.tableList = [];
        this.isClear = false;
        this.selectionMode = this.dialogConfig.data.selectionMode;
        if (this.dialogConfig.data.posPickerData) {
            this.selectedItem = this.dialogConfig.data.posPickerData;
        }
        if (this.dialogConfig.data.dataKey) {
            this.dataKey = this.dialogConfig.data.dataKey;
        }
        if (this.dialogConfig.data.queryModel) {
            this.form.patchValue(this.dialogConfig.data.queryModel);
        }
        if (this.dialogConfig.data.showFullStaffDetail) {
            this.showFullStaffDetail = this.dialogConfig.data.showFullStaffDetail;
        }
        if (this.dialogConfig.data.showAvailableStaff) {
            this.showAvailableStaff = this.dialogConfig.data.showAvailableStaff;
        }
        if (this.dialogConfig.data.showDate) {
            this.showDate = this.dialogConfig.data.showDate;
        }
    }

    lazyLoadData(event: LazyLoadEvent) {
        this.form = this.preparePageable(event, this.form);
        this.listSubscription = this.positionService.queryPositionPage(this.form.value).subscribe((response) => {
            this.tableList = response.data;
            this.totalElements = response.totalElements;
            this.totalPages = response.totalPages;
            this.loading = false;
        });
    }

    onRowSelectClickEvent() {
        if (this.selectionMode == 'select-all') {
            if (this.dynamicDialogRef) this.dynamicDialogRef.close(this.form);
        } else {
            if (!this.selectedItem) {
                this.uiToastMessageService.showWarn(this.translateService.instant('toastMessage.chooseDataFromTable'));
            } else {
                if (this.dynamicDialogRef) {
                    this.dynamicDialogRef.close(this.selectedItem);
                } else this.onRowSelectEventEmitter.emit(this.selectedItem[0]);
            }
        }
    }

    ngOnDestroy() {
        if (this.listSubscription) this.listSubscription.unsubscribe();
    }

    onCancel() {
        this.selectedItem = null;
        this.dynamicDialogRef.close(this.selectedItem);
    }

    onSearch() {
        // this.selectedItem = null;
        this.dataTableRef.reset();
    }

    onClear() {
        this.isClear = true;
        this.form.reset();
        if (this.showFullStaffDetail) {
            this.form.get('showEmptyPosition').setValue(false);
            this.form.get('notIncludedCapacity').setValue(false);
        }
        if (this.showAvailableStaff) {
            this.form.get('showEmptyPosition').setValue(true);
            this.form.get('notIncludedCapacity').setValue(false);
        }

        this.onSearch();
    }
}
